export const iconFontAwesomeScienceSeedling = (
	<i className="fa-solid fa-seedling"></i>
);
